import {
  ActionType,
  BaseActionWidget,
  ClickResult,
  Condition,
  DEFAULT_TRUE_CONDITION,
  ExcelExportMethodEnum,
  ExcelExportTask,
  ExportWorkbookActionWidget,
  ModelDefaultActionName,
  RuntimeContext,
  RuntimeServerAction,
  SPI,
  SubmitValue,
  ViewActionTarget
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseActionWidget.Token({
    name: ModelDefaultActionName.$$internal_ExportWorkbook
  })
)
export class MarkupDetailItemTplExportDialogWidget extends ExportWorkbookActionWidget {
  protected async executeAction(action: RuntimeServerAction, parameters: SubmitValue): Promise<ClickResult> {
    const formData = (this.activeRecords?.[0] as ExcelExportTask) || {};
    let { exportMethod } = formData;
    if (!exportMethod) {
      exportMethod = ExcelExportMethodEnum.TEMPLATE;
    }
    let task: ExcelExportTask;
    switch (exportMethod) {
      case ExcelExportMethodEnum.TEMPLATE: {
        const workbookId = await this.getWorkbookId();
        if (!workbookId) {
          return false;
        }
        task = {
          ...formData,
          exportMethod: undefined,
          selectedFields: undefined,
          workbookDefinition: {
            id: workbookId
          }
        };
        break;
      }
      case ExcelExportMethodEnum.SELECT_TEMPLATE_FIELD: {
        const workbookId = await this.getWorkbookId();
        if (!workbookId) {
          return false;
        }
        task = {
          ...formData,
          workbookDefinition: {
            id: workbookId
          }
        } as ExcelExportTask;
        break;
      }
      case ExcelExportMethodEnum.SELECT_FIELD: {
        task = {
          ...formData,
          workbookDefinition: undefined
        };
        break;
      }
      default:
        return false;
    }
    if (!task) {
      return false;
    }

    if (
      this.openerActiveRecords &&
      this.openerActiveRecords.length > 0 &&
      this.openerActiveRecords[0]['markupDetailItemTplExportWidgetMark'] === 'MarkupDetailItemTplExportWidgetMark'
    ) {
      const filterData = this.openerActiveRecords?.shift();
      let filterCondition: Condition | undefined;

      if (filterData) {
        if (filterData['markupOrganizationType']) {
          filterCondition = new Condition('markupOrganizationType').equal(
            filterData['markupOrganizationType'] as string
          );
        }
        if (filterData['salesOffice'] && (filterData['salesOffice'] as any)['code']) {
          filterCondition &&
            filterCondition.and(
              new Condition('salesOfficeCode').equal((filterData['salesOffice'] as any)['code'] as string)
            );
        }
        if (filterData['distributor'] && (filterData['distributor'] as any)['code']) {
          filterCondition &&
            filterCondition.and(
              new Condition('distributorCode').equal((filterData['distributor'] as any)['code'] as string)
            );
        }
      }

      let condition: Condition | string | undefined;
      let runtimeContext: RuntimeContext | undefined;
      const activeRecords = this.openerActiveRecords;
      if (activeRecords && activeRecords.length) {
        condition = `id =in= (${activeRecords.map((a) => a.id).join(',')})`;
      } else {
        const res = this.buildSearchConditions();
        if (res) {
          condition = res.condition;
          runtimeContext = res.runtimeContext;
        }
      }
      if (!condition) {
        condition = DEFAULT_TRUE_CONDITION;
      }
      if (!runtimeContext) {
        runtimeContext = this.seekSearchRuntimeContext() || this.rootRuntimeContext;
      }

      filterCondition && (condition += ' and ' + filterCondition.toString());

      return this.doExport(runtimeContext, task, condition);
    }

    return await super.executeAction(action, parameters);
  }
}
